import "./MainBackground.css";
function MainBackground({ children }) {
  return (
    <div className="main-background-contenair">
      <div className="main-background-satured"></div>
      <div className="main-background-unsatured">
        <div className="main-background-content">{children}</div>
      </div>
    </div>
  );
}

export default MainBackground;
